/**
 * Copyright (C) Siemens AG 1996-2024 ALL RIGHTS RESERVED.
 */

import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-topic-card',
  templateUrl: './topic-card.component.html',
  styleUrl: './topic-card.component.scss',
  standalone: false,
})
export class TopicCardComponent {
  @Input({alias: 'linkTo'}) link = 'siemens.com';
  @Input({alias: 'heading'}) heading = 'My heading';
  @Input({alias: 'subheading'}) subheading = 'This is a subheading.';
  @Input({alias: 'icon'}) icon = 'coffee-filled';
  @Input({alias: 'color'}) color = '--theme-color-primary';

  openLink() {
    window.open(this.link);
  }
}
